import { render, staticRenderFns } from "./TextareaComponent.vue?vue&type=template&id=46a1b61d&scoped=true"
import script from "./TextareaComponent.vue?vue&type=script&lang=js"
export * from "./TextareaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a1b61d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46a1b61d')) {
      api.createRecord('46a1b61d', component.options)
    } else {
      api.reload('46a1b61d', component.options)
    }
    module.hot.accept("./TextareaComponent.vue?vue&type=template&id=46a1b61d&scoped=true", function () {
      api.rerender('46a1b61d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entries/formComponents/TextareaComponent.vue"
export default component.exports